import type { Map } from 'immutable'
import { useSelector } from 'react-redux'

import { useNumPortions } from 'hooks/basket/useNumPortions'
import { useMaxRecipesForPortion } from 'hooks/menu-boxes/useMaxRecipesForPortion'
import { getIsAuthenticated } from 'selectors/auth'
import { type BasketRecipe, getBasketRecipeQuantity } from 'utils/basket'

export const sumQuantities = (recipes: Map<string, BasketRecipe>) => {
  let total = 0

  recipes.forEach((current) => {
    total += getBasketRecipeQuantity(current)
  })

  return total
}

export const useRecipeLimitReached = (recipes: Map<string, BasketRecipe>): boolean => {
  const { numPortions } = useNumPortions()
  const maxRecipesNum = useMaxRecipesForPortion(numPortions)
  const isAuthenticated = useSelector(getIsAuthenticated)

  return !isAuthenticated && sumQuantities(recipes) >= maxRecipesNum
}
